import React, { useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import Button from '../../Button';

const buildOptions = (arr, labelKey) =>
  (arr || []).map((item) => ({ value: item?.id, label: item?.[labelKey] }));

const getSelectedOption = (options, value) =>
  (options || []).find((o) => String(o.value) === String(value)) || null;

function Contact({ data, patientId, reload }) {
  const [isEdit, setIsEdit] = useState(false);
  const [allDataEdit, setAllDataEdit] = useState(null);

  const { user } = useSelector((state) => state.auth);
  const [formValues, setFormValues] = useState({
    Address1: '',
    Address2: '',
    areaCode: '',
    city: '',
    contact_person: '',
    country: '',
    direct_id: '',
    email: '',
    fax: '',
    home_phone: '',
    mobile_phone: '',
    other_contact: '',
    preferred_mode: '',
    state: '',
    work_phone: '',
    zip: '',
  });

  const handleContactChange = async () => {
    setIsEdit(true);
    try {
      const response = await post('api/patient/Patient/editPatientProfile', {
        patientId: patientId,
      });
      if (response?.status === 200) {
        setAllDataEdit(response?.data);
        const patientDetails = response?.data?.patientDetail;
        setFormValues((ele) => {
          return {
            ...ele,
            Address1: patientDetails?.address,
            Address2: patientDetails?.correspondence_address,
            areaCode: patientDetails?.area_code,
            city: patientDetails?.city,
            contact_person: patientDetails?.contact,
            country: patientDetails?.country,
            direct_id: patientDetails?.secure_email,
            email: patientDetails?.email,
            fax: patientDetails?.fax,
            home_phone: patientDetails?.home_phone,
            mobile_phone: patientDetails?.mobile,
            other_contact: patientDetails?.other_contact,
            preferred_mode: patientDetails?.preferred_mode,
            state: patientDetails?.state,
            work_phone: patientDetails?.office_desk_telephone,
            zip: patientDetails?.zip,
          };
        });
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleSelectChange = (id, option) => {
    setFormValues((ele) => {
      return { ...ele, [id]: option ? option.value : '' };
    });
  };

  const handleFieldChange = ({ target: { id, value } }) => {
    setFormValues((ele) => {
      return { ...ele, [id]: value };
    });
  };

  const handleSave = async () => {
    try {
      let status = true;
      if (formValues?.preferred_mode === '0' && formValues?.email === '') {
        status = false;
        setUiMessage('err', 'E-mail is required.');
      }
      if (
        formValues?.preferred_mode === '1' &&
        formValues?.mobile_phone === ''
      ) {
        status = false;
        setUiMessage('err', 'Mobile is required for text message.');
      }

      if (
        formValues?.preferred_mode === '4' &&
        formValues?.mobile_phone === ''
      ) {
        status = false;
        setUiMessage('err', 'Mobile phone is required.');
      }

      if (formValues?.preferred_mode === '2' && formValues?.home_phone === '') {
        status = false;
        setUiMessage('err', 'Home Phone is required.');
      }

      if (formValues?.preferred_mode === '3' && formValues?.Address1 === '') {
        status = false;
        setUiMessage('err', 'Address1 is required.');
      }

      if (formValues?.preferred_mode === '3' && formValues?.city === '') {
        status = false;
        setUiMessage('err', 'City is required.');
      }

      if (formValues?.preferred_mode === '3' && formValues?.state === '') {
        status = false;
        setUiMessage('err', 'State is required.');
      }

      if (formValues?.preferred_mode === '3' && formValues?.country === '') {
        status = false;
        setUiMessage('err', 'Country is required.');
      }

      if (status) {
        setIsEdit(false);
        const response = await post('api/patient/Patient/updatePatient', {
          updateInfo: 'Contact-Mode',
          flag: '1',
          patient_id: patientId,
          preferred_mode: formValues?.preferred_mode,
          home_phone: formValues?.home_phone,
          mobile: formValues?.mobile_phone,
          office_desk_telephone: formValues?.work_phone,
          contact: formValues?.contact_person,
          email: formValues?.email,
          secure_email: formValues?.direct_id,
          fax: formValues?.fax,
          other_contact: formValues?.other_contact,
          address: formValues?.Address1,
          correspondence_address: formValues?.Address2,
          city: formValues?.city,
          area_code: formValues?.areaCode,
          country: formValues?.country,
          zip: formValues?.zip,
          loginUserId: user?.id,
        });
        if (response?.status === 200) {
          reload();
        }
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };
  return (
    <>
      {isEdit ? (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Contact:</div>
            <div
              className="chld-hdr-edt"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                variant="default"
                onClick={() => setIsEdit(false)}
                style={{ fontSize: '13px', padding: '3px 12px' }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleSave}
                style={{ fontSize: '13px', padding: '3px 12px' }}
              >
                Save
              </Button>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Preferred Mode:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val">
                  {(() => {
                    const preferredModeOptions = buildOptions(
                      allDataEdit?.contactDetailArr?.preferred_mode,
                      'val'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          preferredModeOptions,
                          formValues.preferred_mode
                        )}
                        options={preferredModeOptions}
                        onChange={(opt) =>
                          handleSelectChange('preferred_mode', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Address1:
                  {formValues?.preferred_mode === '3' && (
                    <span className="required-fld">*</span>
                  )}
                </span>

                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="Address1"
                    value={formValues.Address1 || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Area Code:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const areaCodeOptions = buildOptions(
                      allDataEdit?.contactDetailArr?.areaCode,
                      'area_name'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          areaCodeOptions,
                          formValues.areaCode
                        )}
                        options={areaCodeOptions}
                        onChange={(opt) =>
                          handleSelectChange('areaCode', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Home Phone:
                  {formValues?.preferred_mode === '2' && (
                    <span className="required-fld">*</span>
                  )}
                </span>

                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="home_phone"
                    value={formValues.home_phone || ''}
                    onChange={handleFieldChange}
                    maxLength="10"
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Address2:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="Address2"
                    value={formValues.Address2 || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Direct ID:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="direct_id"
                    value={formValues.direct_id || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Mobile Phone:
                  {(formValues?.preferred_mode === '1' ||
                    formValues?.preferred_mode === '4') && (
                    <span className="required-fld">*</span>
                  )}
                </span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="mobile_phone"
                    value={formValues.mobile_phone || ''}
                    onChange={handleFieldChange}
                    maxLength="10"
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  City:
                  {formValues?.preferred_mode === '3' && (
                    <span className="required-fld">*</span>
                  )}
                </span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="city"
                    value={formValues.city || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Other Phone#:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="other_contact"
                    value={formValues.other_contact || ''}
                    onChange={handleFieldChange}
                    maxLength="10"
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Work Phone:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="work_phone"
                    value={formValues.work_phone || ''}
                    onChange={handleFieldChange}
                    maxLength="10"
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  State:
                  {formValues?.preferred_mode === '3' && (
                    <span className="required-fld">*</span>
                  )}
                </span>
                <span className="nsu-act-val">
                  {(() => {
                    const stateOptions = buildOptions(
                      allDataEdit?.contactDetailArr?.stateList,
                      'iso_code'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          stateOptions,
                          formValues.state
                        )}
                        options={stateOptions}
                        onChange={(opt) => handleSelectChange('state', opt)}
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Contact Person:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="contact_person"
                    value={formValues.contact_person || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Email ID:
                  {formValues?.preferred_mode === '0' && (
                    <span className="required-fld">*</span>
                  )}
                </span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="email"
                    value={formValues.email || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Zip:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="zip"
                    value={formValues.zip || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">&nbsp;</span>
                <span className="nsu-act-val">&nbsp;</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Fax:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="fax"
                    value={formValues.fax || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Country:
                  {formValues?.preferred_mode === '3' && (
                    <span className="required-fld">*</span>
                  )}
                </span>
                <span className="nsu-act-val">
                  {(() => {
                    const countryOptions = buildOptions(
                      allDataEdit?.contactDetailArr?.countryList,
                      'country_name'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          countryOptions,
                          formValues.country
                        )}
                        options={countryOptions}
                        onChange={(opt) => handleSelectChange('country', opt)}
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">&nbsp;</span>
                <span className="nsu-act-val">&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Contact:</div>
            <div className="chld-hdr-edt">
              <span className="demo-edt-icn" onClick={handleContactChange}>
                &#9998;
              </span>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Preferred Mode:</span>
                <span className="nsu-act-val maroon">
                  {data?.preferred_mode}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Address1:</span>
                <span className="nsu-act-val">{data?.Address1}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Area Code:</span>
                <span className="nsu-act-val">{data?.areaCode}</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Home Phone:</span>
                <span className="nsu-act-val">{data?.home_phone}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Address2:</span>
                <span className="nsu-act-val">{data?.Address2}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Direct ID:</span>
                <span className="nsu-act-val">{data?.direct_id}</span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Mobile Phone:</span>
                <span className="nsu-act-val">{data?.mobile_phone}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">City:</span>
                <span className="nsu-act-val">{data?.city}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Other Phone#:</span>
                <span className="nsu-act-val">{data?.other_contact}</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Work Phone:</span>
                <span className="nsu-act-val">{data?.work_phone}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">State:</span>
                <span className="nsu-act-val">{data?.state}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Contact Person:</span>
                <span className="nsu-act-val">{data?.contact_person}</span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Email ID:</span>
                <span className="nsu-act-val">{data?.email}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Zip:</span>
                <span className="nsu-act-val">{data?.zip}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">&nbsp;</span>
                <span className="nsu-act-val">&nbsp;</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Fax:</span>
                <span className="nsu-act-val">{data?.fax}</span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Country:</span>
                <span className="nsu-act-val">{data?.country}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">&nbsp;</span>
                <span className="nsu-act-val">&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Contact;
